import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import styled from '../../styles/styled';
import Theme from '../../styles/theme';
import { keyframes } from '@emotion/react';
import { Row } from '../layout';
/**
 * Placeholder UI element with animated dots
 */
const SkeletonContainer = styled.div({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gridColumn: 'span 2',
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: Theme.colors.grey05,
});
const blink = keyframes `
    from {
        opacity: .2;
    }
    50% {
        opacity: 1;
    }
    to {
        opacity: .2;
    }
`;
const BlinkingDot = styled.div({
    width: '16px',
    height: '16px',
    backgroundColor: 'rgba(63, 103, 139)',
    overflow: 'visible',
    borderRadius: '50%',
    margin: '0 8px',
    animation: `${blink} 1.2s infinite`,
}, ({ delay }) => {
    return {
        animationDelay: delay,
    };
});
export const Skeleton = ({ children, styleOverrides, }) => {
    return (_jsxs(SkeletonContainer, { "data-testid": "video skeleton", style: styleOverrides, children: [_jsxs(Row, { my: 1, alignItems: "center", children: [_jsx(BlinkingDot, { delay: "0s" }), _jsx(BlinkingDot, { delay: ".2s" }), _jsx(BlinkingDot, { delay: ".4s" })] }), children] }));
};
//# sourceMappingURL=skeleton.js.map